import React, { Fragment, useCallback, useMemo } from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Carousel from "../../components/Carousel";
import GameCatalog from "../../components/GameCatalog";
import { useTranslation } from "react-i18next";
import SupplierList from "../../components/GameSelect/SupplierList";
import { useLocation, useNavigation } from "react-router";
import MobileSearch from "../Search/mobile-search";
import TopTab from "./components/topTab";
import useSubTypeList from "../../hook/useSubTypeList";
import List from "../Promotion/components/LIST";
import { filterType } from "../../hook/useGameListFilter";
import useCasinoType from "../../hook/useCasinoType";
import FavoriteGameCatalog from "../../components/FavoriteGameCatalog";
import LoadingForLiveLayout from "../../components/Loading/LoadingForLiveLayout";
import { isLoggedIn } from "../../utils/isLoggedIn";
import UserClickGameCatalog from "../../components/UserClickGameCatalog";
import MarqueeList from "../../components/marquee/marqueeList";

const Home = ({}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const subList = useSubTypeList();

  const casinoType = useCasinoType();

  const dispatch = useDispatch();
  const handleAllGame = useSelector((state) => state.isHandleAllGame); //redux純取值用useSelector就好 不用dispatch
  const loadingStatus = useSelector((state) => state.isLoaderStatus);
  //把Redux store 中的 isHandleAllGame 属性，儲存在 handleAllGame 變量中
  const {
    platform,
    topGameList,
    newGameList,
    categorizedGames,
    exclusiveBrandGames,
  } = handleAllGame; //從handleAllGame中提取了 platform、gameList 和 gameType 属性。可以在组件中直接使用这些属性，而不必每次都通过handleAllGame 来訪問它们。

  const location = useLocation();
  const { pathname } = location;

  const promotionList = List();

  const topGames = filterType({
    gameList: topGameList,
    casinoType: casinoType,
  });

  const newGames = filterType({
    gameList: newGameList,
    casinoType: casinoType,
  })?.reverse();

  const lobbyGames = useMemo(() => {
    return filterType({
      gameList: categorizedGames?.Lobby,
      casinoType: "live-casino",
    }); //從redux取categorizedGames裡面的Lobby 記得問號防呆
  }, [categorizedGames]);

  const subGames = useMemo(() => {
    return subList
      ?.filter((item) => item !== "MyFavorite" && item !== "ClickGames")
      ?.map((subType, index) => {
        const subGamelist = filterType({
          gameList: categorizedGames?.[subType],
          casinoType: casinoType,
        });

        return (
          subGamelist?.length > 10 && (
            <Fragment key={subType}>
              <GameCatalog
                list={subGamelist}
                wrapperClassName={subGamelist?.length === 0 && "hidden"}
                mainTitle={subType}
              />
              {index === 5 && (
                <section className="px-common-padding-x mb-[20px]">
                  <SupplierList
                    LIST={platform}
                    customNavigate="/casino/category/"
                  />
                </section>
              )}
            </Fragment>
          )
        );
      });
  }, [categorizedGames, subList]);

  return (
    <Fragment>
      <section className="md:hidden">
        <TopTab />
      </section>
      <section className="py-common-padding-y">
        <section className="px-common-padding-y">
          <Carousel />
        </section>
      </section>
      <section className="md:!pb-0 pb-common-padding-y px-common-padding-y">
        <MarqueeList />
      </section>
      <section className="md:hidden">
        <MobileSearch />
      </section>
      <section>
        {isLoggedIn() ? (
          <>
            <UserClickGameCatalog />
          </>
        ) : null}
        <GameCatalog
          list={topGames}
          wrapperClassName={topGames?.length === 0 && "hidden"}
          mainTitle={"Top"}
          observeFalse
        />

        <GameCatalog
          list={newGames}
          wrapperClassName={newGames?.length === 0 && "hidden"}
          mainTitle={"News"}
          itemClass="xl:!h-[250px]"
          swiperProps={{
            customPerView: "new-game-layout",
          }}
          observeFalse
        />
        <GameCatalog
          list={[...promotionList]}
          mainTitle={"Promotions"}
          listType="promotion"
          itemClass="!h-[250px]"
          swiperProps={{
            delay: 1,
            speed: 25000,
            swiperClassName: "custom-swiper-wrapper",
            customPerView: "promotion-layout",
          }}
          observeFalse
        />

        {loadingStatus ? (
          <LoadingForLiveLayout itemClass="md:!h-[300px] h-[180px]" />
        ) : (
          <GameCatalog
            list={lobbyGames}
            mainTitle={"Lobby"}
            itemClass="md:!h-[300px] h-[180px]"
            swiperProps={{
              delay: 1,
              speed: 25000,
              swiperClassName: "custom-swiper-wrapper",
              customPerView: "live-layout",
            }}
          />
        )}
        <GameCatalog
          list={exclusiveBrandGames}
          wrapperClassName={exclusiveBrandGames?.length === 0 && "hidden"}
          mainTitle={"ExclusiveGame"}
          itemClass="xl:!h-[250px]"
          swiperProps={{
            customPerView: "new-game-layout",
          }}
        />
      </section>
      <section>{subGames}</section>
    </Fragment>
  );
};

export default React.memo(Home);
